module.exports = __webpack_public_path__ + "fonts/Montserrat-Bold.2c15581.ttf";